import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { FamilyPlanLandingProps } from '@/components/familyPlan/FamilyPlanLanding/types';
import GridWrapper from '@/components/ui/GridWrapper';

import { faqItems } from './data';
import messages from './messages';
import { Answer, Arrow, ButtonWrapper, FaqItem, FaqItems, Heading, Question, Wrapper } from './styles';

const Faq = ({ onClick }: FamilyPlanLandingProps) => {
	const { formatMessage } = useIntl();

	const [activeFaqItems, setActiveFaqItems] = useState<Record<string, boolean>>({});

	const onFaqItemClick = (index: number) => {
		const newKeyValue = { [index]: !activeFaqItems[index] };

		setActiveFaqItems({
			...activeFaqItems,
			...newKeyValue,
		});
	};

	return (
		<GridWrapper>
			<Wrapper>
				<Heading>{formatMessage(messages.heading)}</Heading>
				<FaqItems>
					{faqItems.map((item, index) => (
						<FaqItem key={formatMessage(item.question)} isActive={activeFaqItems[index]}>
							<Question onClick={() => onFaqItemClick(index)}>
								{formatMessage(item.question)}
								<Arrow />
							</Question>
							<Answer>
								{formatMessage(item.answer, {
									break: (
										<>
											<br />
											<br />
										</>
									),
									externallink: chunks => (
										<a href={item.url} target="_blank" rel="noopener noreferrer">
											{chunks}
										</a>
									),
								})}
							</Answer>
						</FaqItem>
					))}
				</FaqItems>
				<ButtonWrapper>
					<Button
						fullWidth
						onPress={() =>
							onClick &&
							onClick({
								section: 'faq',
								copy: messages.cta.defaultMessage,
							})
						}
						backgroundColor="gradientCalmBrand"
						textColor="white"
					>
						{formatMessage(messages.cta)}
					</Button>
				</ButtonWrapper>
			</Wrapper>
		</GridWrapper>
	);
};

export default Faq;
